import request from "@/utils/request";
const qs = require("qs");
import { MLMReport } from "@/utils/requestApi";

// progresss

export function listPaid(data) {
  return request({
    url: MLMReport() + "/purchase_order/list_paid",
    method: "POST",
    data: qs.stringify(data)
  });
}



// WEBPACK FOOTER //
// ./src/api/listPaid.js